import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api'
import { RiServerLine } from '@remixicon/react'

const fleetPage = PageBlueprint.make({
  params: {
    path: '/fleet',
    title: 'Fleet',
    icon: <RiServerLine size="1em" />,
    loader: async () => {
      const { FleetPage } = await import('./FleetPage')
      return <FleetPage />
    },
  },
})

export const fleetPlugin = createFrontendPlugin({
  pluginId: 'dg-fleet',
  extensions: [fleetPage],
})
